import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row, Card, Modal } from "react-bootstrap";
import moment from "moment";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import {
  HIDEREVIEW,
  REVIEWLIST,
  REVIEWREPLY,
  REVIEWSTATS,
} from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
const ReviewManagement = () => {
  const { t } = useTranslation();
  const filterKeys = ["rating"];
  const [stats, setStats] = useState({});
  const [replies, setReplies] = useState({}); // Store replies per review ID
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedReviewId, setSelectedReviewId] = useState(null);
  const [hideReason, setHideReason] = useState("");
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
    refetch,
  } = dataHandler({
    api: REVIEWLIST,
    dependencyArr: filterKeys,
    extraBody: {
      rating: ""
    }
  });

  console.log("data", data);

  const handleHide = (reviewId) => {
    setSelectedReviewId(reviewId);
    setShowReasonModal(true);
  };
  const getReviewStats = async () => {
    try {
      let res = await REVIEWSTATS();
      console.log(res, "res message");
      if (res?.data?.status === "success") {
        setStats(res.data?.reviewStat || {});
      }
    } catch (error) {
      console.error("Error fetching review stats:", error);
    }
  };
  const handleSubmitHideReason = async () => {
    if (!hideReason.trim()) return;

    try {
      // Example payload
      const payload = {
        _id: selectedReviewId,
        reason: hideReason,
      };
      let res = await HIDEREVIEW(payload);
      if (res?.data?.status === "success") {

        toast.success("Hide request sent successfully");

        setShowReasonModal(false);
        setHideReason("");
        setSelectedReviewId(null);
        refetch();
      }

      // 👉 Call your API here
      // await REQUEST_HIDE_REVIEW(payload);


    } catch (error) {
      toast.error("Failed to request hide");
    }
  };

  useEffect(() => {
    getReviewStats();
  }, []);



  console.log(stats, "stat===<>data");
  console.log(data, "data===<>");

  const renderStars = (rating) => (
    <div>
      {[...Array(5)].map((_, i) => (
        <span
          key={i}
          style={{
            color: i < rating ? "#f5c518" : "#ddd",
            fontSize: "16px",
            marginRight: 2,
          }}
        >
          ★
        </span>
      ))}
    </div>
  );

  const handleSubmit = async (e, id) => {
    e.preventDefault();
    const replyMessage = replies[id] || "";
    if (!replyMessage.trim()) {
      toast.error("Please enter a reply message");
      return;
    }
    const payload = {
      message: replyMessage.trim(),
      id
    };
    try {
      let res = await REVIEWREPLY(payload);
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message || "Reply sent successfully");
        setReplies((prev) => ({ ...prev, [id]: "" })); // Clear reply for this review
        refetch(); // Refresh the review list to show the new reply
      } else {
        toast.error(res?.data?.message || "Failed to send reply");
      }
    } catch (error) {
      toast.error(error?.message || "Failed to send reply");
    }
  }

  const handleReplyChange = (reviewId, value) => {
    setReplies((prev) => ({ ...prev, [reviewId]: value }));
  }
  return (
    <section className="review-management py-4">
      <Modal
  show={showReasonModal}
  onHide={() => setShowReasonModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Reason to Hide Review</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form.Group>
      <Form.Label>Reason</Form.Label>
      <Form.Control
        as="textarea"
        rows={4}
        placeholder="Enter reason for hiding this review"
        value={hideReason}
        onChange={(e) => setHideReason(e.target.value)}
      />
    </Form.Group>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowReasonModal(false)}
    >
      Cancel
    </Button>

    <Button
      variant="primary"
      onClick={handleSubmitHideReason}
      disabled={!hideReason.trim()}
    >
      Submit
    </Button>
  </Modal.Footer>
</Modal>
      <Container>
        <Row className="mb-4">
          <Col>
            <h4 className="fw-bold text-dark mb-0">
              {t("review.title")}
            </h4>
          </Col>
        </Row>

        <Row className="g-3 mb-4">
          {[
            {
              title: t("review.stats.averageScore"),
              value: data?.reviewStat?.avgRating ? parseInt(data?.reviewStat?.avgRating)?.toFixed(1) : 0,
              color: "#e8307a",
              stars: true,
            },
            {
              title: t("review.stats.totalVisible"),
              value: data?.reviewStat?.totalVisibleReviews ?? 0,
              color: "#000",
            },
            {
              title: t("review.stats.hidden"),
              value: data?.reviewStat?.totalHiddenReviews ?? 0,
              color: "#d9534f",
            }
          ].map((card, i) => (
            <Col lg={3} md={6} sm={6} key={i}>
              <Card
                className="shadow-sm border-0 text-center h-100"
                style={{
                  borderRadius: "12px",
                  background: "#e8307a21",
                  padding: "18px",
                }}
              >
                <Card.Body className="p-2">
                  <h6 className="text-muted mb-2">{card?.title}</h6>
                  <h3
                    className="fw-bold mb-1"
                    style={{ color: card?.color, fontSize: "1.8rem" }}
                  >
                    {card?.value}
                  </h3>
                  {card?.stars &&
                    renderStars(Math.round(stats?.summary?.averageRating))}
                  {card?.subText && (
                    <small className="text-muted">{card?.subText}</small>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* ====== Filters ====== */}

        <div
          className="bg-white rounded-3 shadow-sm p-3 mb-4 d-flex flex-wrap align-items-center gap-3"
          style={{ border: "1px solid #fff" }}
        >
          <div>
            <Form.Label className="fw-semibold text-muted mb-1 d-block">
              {t("review.filters.rating")}

            </Form.Label>
            <Form.Select
              size="sm"
              value={body?.rating}
              onChange={(e) =>
                setBody((prev) => ({ ...prev, rating: e.target.value }))
              }
              style={{ width: 150 }}
            >
              <option value=""> {t("review.filters.allRatings")}</option>
              {[5, 4, 3, 2, 1].map((r) => (
                <option key={r} value={r}>

                  {t("review.filters.stars", { count: r })}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <Form.Label className="fw-semibold text-muted mb-1 d-block">
              {t("review.filters.status")}
            </Form.Label>
            <Form.Select
              size="sm"
              value={body.status}
              onChange={(e) =>
                setBody((prev) => ({ ...prev, status: e.target.value }))
              }
              style={{ width: 150 }}
            >
              <option value="">{t("review.filters.allStatus")}</option>
              <option value="Visible">{t("review.status.visible")}</option>
              <option value="Hidden">{t("review.status.hidden")}</option>
              <option value="Deleted">{t("review.status.deleted")}</option>
            </Form.Select>
          </div>

          <div className="mt-3 mt-sm-4">
            <Button
              variant="primary"
              size="sm"
              className="fw-semibold"
              style={{
                backgroundColor: "#e8307a",
                borderColor: "#e8307a",
                minWidth: "100px",
              }}
              onClick={() =>
                setBody((p) => ({ ...p, rating: "", status: "" }))
              }
            >
              {t("review.actions.clearFilters")}
            </Button>
          </div>
        </div>

        {/* ====== Review Cards ====== */}

        {data?.resdata?.map((item) => (
          <Card
            key={item?._id}
            className="shadow-sm mb-3 border-0 rounded-3"
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "10px 15px",
            }}
          >
            <Card.Body>
              {/* ===== Header (Customer name + date + status) ===== */}
              <div className="d-flex justify-content-between align-items-start flex-wrap">
                <div>
                  <h6 className="fw-bold text-dark mb-1">
                    {item?.customerId
                      ? `${item.customerId.first_name || ""} ${item.customerId.last_name || ""}`.trim()
                      : t("review.labels.unknownUser")}
                  </h6>

                  {/* Overall rating stars */}
                  {renderStars(item?.rating || 0)}
                </div>

                <div className="text-end">
                  <small className="text-muted d-block mb-1">
                    {moment(item?.createdAt).format("YYYY-MM-DD")}
                  </small>
                  {!item.isRequestedToHide && <button onClick={() => handleHide(item._id)} className="btn-primary">
                    Request To Hide
                  </button>}
                  {/* <span
                    className="badge"
                    style={{
                      backgroundColor:
                        item?.status === "active"
                          ? "#28a745"
                          : item?.status === "hidden"
                            ? "#6c757d"
                            : "#d9534f",
                      textTransform: "capitalize",
                    }}
                  >
                    {item?.status}
                  </span> */}
                </div>
              </div>

              {/* ===== Review message ===== */}
              <p className="mt-2 text-secondary mb-2">{item?.message}</p>
              <hr className="my-2" />

              {/* ===== Sub ratings breakdown ===== */}
              <div className="mb-2 text-muted small">
                <div>
                  <strong>{t("review.labels.hotel")}:</strong> {item?.hotelId?.hotelName || "N/A"}
                </div>
                {/* <div>
                  <strong>Room:</strong>{" "}
                  {item?.room?.roomNumber
                    ? `Room ${item?.room?.roomNumber}, Floor ${item?.room?.floorNumber}`
                    : "N/A"}
                </div> */}
                <div>
                  <strong>{t("review.labels.bookingId")}:</strong> {item?.bookingId?.bookingId || "N/A"}
                </div>
              </div>

              {/* ===== Existing Replies ===== */}
              {/* {item?.replies && item.replies.length > 0 && (
                <>
                  <hr className="my-3" />
                  <div className="mb-3">
                    <h6 className="fw-semibold text-dark mb-2">
                      {t("review.replies.title", "Replies")} ({item.replies.length})
                    </h6>
                    <div className="ps-3">
                      {item.replies.map((replyItem, idx) => (
                        <div
                          key={replyItem._id || idx}
                          className="mb-3 p-3 rounded"
                          style={{
                            backgroundColor: "#f8f9fa",
                            borderLeft: "3px solid #e8307a",
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <small className="text-muted fw-semibold">
                              {t("review.replies.adminReply", "Hotel Owner Reply")}
                            </small>
                            <small className="text-muted">
                              {moment(replyItem.createdAt).format("YYYY-MM-DD HH:mm")}
                            </small>
                          </div>
                          <p className="mb-0 text-secondary">{replyItem.message}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )} */}

              <hr className="my-2" />

              {/* ===== Action and reply area ===== */}
              <div className="d-flex flex-column gap-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <small className="text-muted">
                    {item?.description}
                  </small>
                </div>

                {/* <Form onSubmit={(e) => handleSubmit(e, item?._id)}>
                  <div className="d-flex gap-2 flex-grow-1">
                    <Form.Control
                      type="text"
                      value={replies[item?._id] || ""}
                      placeholder={t("review.reply.placeholder", "Type your reply...")}
                      size="sm"
                      onChange={(e) => handleReplyChange(item?._id, e.target.value)}
                      className="shadow-sm"
                      style={{
                        flex: 1,
                        borderRadius: "8px",
                      }}
                    />
                    <Button
                      type="submit"
                      size="sm"
                      disabled={loader}
                      style={{
                        backgroundColor: "#e8307a",
                        borderColor: "#e8307a",
                        minWidth: "100px",
                      }}
                    >
                      {loader ? t("common.loading", "Loading...") : t("review.reply.submit", "Reply")}
                    </Button>
                  </div>
                </Form> */}
              </div>
            </Card.Body>
          </Card>
        ))}

        {/* ====== Pagination ====== */}
        <CustomPagination
          total={total}
          pageChangeHandler={paginationHandler}
          body={body}
          setBody={setBody}
        />
      </Container>
    </section>
  );
};

export default ReviewManagement;


